import React, { useState, useEffect } from 'react';
import './AnimatedBear.css';

const AnimatedBear = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  useEffect(() => {
    // Only track mouse on desktop
    if (isMobile) return;

    const handleMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
      setIsVisible(true);
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isMobile]);

  const BearSVG = () => (
    <svg
      width={isMobile ? "80" : "60"}
      height={isMobile ? "80" : "60"}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Bear Face */}
      <circle cx="50" cy="50" r="35" fill="#FFD700" />
      
      {/* Ears */}
      <circle cx="25" cy="25" r="18" fill="#FFD700" />
      <circle cx="75" cy="25" r="18" fill="#FFD700" />
      <circle cx="25" cy="25" r="10" fill="#FFA500" />
      <circle cx="75" cy="25" r="10" fill="#FFA500" />
      
      {/* Eyes */}
      <circle cx="40" cy="45" r="4" fill="#333" />
      <circle cx="60" cy="45" r="4" fill="#333" />
      <circle cx="41" cy="44" r="2" fill="white" />
      <circle cx="61" cy="44" r="2" fill="white" />
      
      {/* Nose */}
      <ellipse cx="50" cy="58" rx="8" ry="6" fill="#333" />
      
      {/* Mouth */}
      <path
        d="M 50 58 Q 45 63 40 60 M 50 58 Q 55 63 60 60"
        stroke="#333"
        strokeWidth="2"
        fill="none"
      />
      
      {/* Cheeks */}
      <circle cx="32" cy="55" r="6" fill="#FFB6C1" opacity="0.6" />
      <circle cx="68" cy="55" r="6" fill="#FFB6C1" opacity="0.6" />
    </svg>
  );

  // Mobile version - fixed floating
  if (isMobile) {
    return (
      <div className="animated-bear-mobile">
        <BearSVG />
      </div>
    );
  }

  // Desktop version - follows cursor
  return (
    <div
      className={`animated-bear-desktop ${isVisible ? 'visible' : ''}`}
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
      }}
    >
      <BearSVG />
    </div>
  );
};

export default AnimatedBear;